import {AnyAction} from 'redux';

// TODO @compel: Code review + Případně přesunout do @mc/redux
/**
 * Skupinový reducer.
 *
 * Přepošle akci na reducerům všech podřízených stavů.
 *
 * V případě, že potřebujete akci směrovat na specifický podřízený reducer
 * dle hodnoty parametru `area`, použijte `AreaGroupReducer`
 *
 *  **Použití:**
 * ```
 * const initialState = {
 *     group: GroupReducer({
 *         foo: FooReducer(),
 *         bar: BarReducer(),
 *     }),
 * };
 * ```
 *
 * @param state - Aktuální stav.
 * @param action - Akce.
 * @returns Nový stav.
 * @ignore
 */
export default function GroupReducer(state: any = {}, action?: AnyAction) {
    if (!action) {
        return {
            ...state,
            reducer: GroupReducer,
        };
    }

    let changed = false;
    let newState = state;

    for (const key in state) {
        if (key !== 'reducer') {
            const subState = state[key];
            if (subState && typeof subState.reducer === 'function') {
                const newSubState = subState.reducer(subState, action);
                if (newSubState !== subState) {
                    if (!changed) {
                        newState = {...state};
                        changed = true;
                    }
                    newState[key] = newSubState;
                }
            }
        }
    }

    return newState;
}
